<form
  class="newsletter-form"
  [class.newsletter-form--footer]="variant() === 'footer'"
  [class.newsletter-form--hero]="variant() === 'hero'"
  [class.newsletter-form--sidebar]="variant() === 'sidebar'"
  [class.newsletter-form--inline]="variant() === 'inline'"
  [class.newsletter-form--popup]="variant() === 'popup'"
  [formGroup]="form"
  (submit)="$event.preventDefault(); submit()"
  novalidate
>
  @if (heading()) {
    <h3 class="newsletter-form__heading">{{ heading() }}</h3>
  }
  @if (description()) {
    <p class="newsletter-form__description">{{ description() }}</p>
  }
  <div class="newsletter-form__row">
    <div class="newsletter-form__field">
      <app-input
        [id]="inputId()"
        type="email"
        formControlName="email"
        [ariaLabel]="copy.EMAIL_LABEL"
        [placeholder]="placeholder()"
        [error]="errorFor()"
      />
    </div>
    <app-button
      variant="primary"
      type="submit"
      [loading]="loading()"
      [disabled]="coolingDown()"
    >
      {{ ctaLabel() }}
    </app-button>
  </div>
  <app-newsletter-consent class="newsletter-form__consent" />

  <!-- Honeypot (W3): fuera del viewport, nunca display:none (mismo patrón que los comentarios del blog). -->
  <div class="newsletter-form__hp" aria-hidden="true">
    <!-- Sin `name`: los gestores de contraseñas rellenan `website`/`url` aunque haya autocomplete="off". -->
    <input
      type="text"
      formControlName="website"
      tabindex="-1"
      autocomplete="off"
      data-lpignore="true"
      data-1p-ignore
      data-bwignore
      data-form-type="other"
    />
  </div>
</form>
